<template>
	<div class="c-product__amount--control">
		<div :class="['c-product__amount--minus', { disabled: totalAmount < 2 }]" tabindex="0" @click="minusAmount" @keyup.enter="minusAmount"><i class="fal fa-minus" /><span class="sr-only">Minder</span></div>
		<div class="c-product__amount--nr">
			<input v-model="totalAmount" type="text" pattern="\d*" name="amount" min="1" max="999" maxlength="3" @change="setAmount()" @keypress="isNumber($event)" />
		</div>
		<div :class="['c-product__amount--plus', { disabled: totalAmount > 998 }]" tabindex="0" @click="plusAmount" @keyup.enter="plusAmount"><i class="fal fa-plus" /><span class="sr-only">Meer</span></div>
	</div>
</template>

<script>
const setAmountTimeouts = [];

export default {
	props: {
		amount: {
			type: Number,
			required: true
		}
	},
	data() {
		return {
			totalAmount: this.amount
		};
	},
	watch: {
		amount: function(newVal, oldVal) {
			this.totalAmount = newVal;
		}
	},
	methods: {
		isNumber: function(evt) {
			evt = evt || window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
				evt.preventDefault();
			} else {
				return true;
			}
		},
		minusAmount() {
			window.clearTimeout(setAmountTimeouts[this._uid]);
			this.totalAmount--;
			setAmountTimeouts[this._uid] = window.setTimeout(this.setAmount, 0);
		},

		plusAmount() {
			window.clearTimeout(setAmountTimeouts[this._uid]);
			this.totalAmount++;
			setAmountTimeouts[this._uid] = window.setTimeout(this.setAmount, 0);
		},

		setAmount() {
			this.$emit('changeAmount', parseInt(this.totalAmount));
		}
	}
};
</script>
